import BasicButton from '../../components/BasicButton';
import { deleteUserMessage, useUserMessages } from '../../misc/lib/contact';
import './AdminPage.scss';

const ContactAdminPanel = () => {
  const messages = useUserMessages();

  return (
    <div className="adminpage-contact-panel">
      <h2>Felhasználói üzenetek</h2>
      <div className="adminpage-contact-message-list">
        { messages.map((m, i) => (
          <div key={ i } className="adminpage-message-card">
            <h3>{ m.message.subject }</h3>
            <p><b>{ m.author.name }</b> - { m.author.email }</p>
            <p>{ m.message.body }</p>
            <div className="adminpage-message-actions">
              <BasicButton text="Válasz" type="secondary" onClick={ () => {
                window.open(`mailto:${ m.author.email }`, '_blank');
              } } />
              <BasicButton text="Törlés" type="warning" onClick={ () => {
                deleteUserMessage(m.id).catch((err) => {
                  console.error(err);
                });
              } } />
            </div>
          </div>
        )) }
      </div>
    </div>
  );
};

export default ContactAdminPanel;
